const delay=10; // Updated for stats tracking
async function partition(arr: any[],minIndex:number,maxIndex:number,updateArray:Function,speed:number=50,updateStats?:(stats: { comparisons?: number; swaps?: number }) => void):Promise<number>{
    var pivot=maxIndex;
    let i=minIndex-1,j;
    
    // Highlight pivot
    updateArray(arr, [pivot]);
    await sleep(speed);
    
    for(j=i+1;j<pivot;j++){
        // Highlight elements being compared
        updateArray(arr, [j, pivot]);
        if (updateStats) {
            updateStats({ comparisons: 1 }); // Increment by 1
        }
        await sleep(speed / 2);
        
        if(arr[j].value<arr[pivot].value){
            i+=1;
            await swap(arr,i,j,updateArray,speed);
            if (updateStats) {
                updateStats({ swaps: 1 }); // Increment by 1
            }
        }
    }
    i+=1;
    await swap(arr,i,pivot,updateArray,speed);
    if (updateStats) {
        updateStats({ swaps: 1 }); // Increment by 1
    }
    return i;
}
export async function sleep(delay : number){
    await new Promise(r => setTimeout(r, delay));
}
async function swap(arr: any[],i:number,j:number,updateArray:Function,speed:number=50):Promise<void>{
    // Show elements being compared
    updateArray(arr, [i, j]);
    await sleep(speed / 2);
    
    // Perform the swap
    let temp=arr[i];
    arr[i]=arr[j];
    arr[j]=temp;
    
    // Show elements being swapped
    updateArray(arr, undefined, [i, j]);
    await sleep(speed / 2);
    
    // Reset colors
    updateArray(arr);
}
export async function quickSort(arr:any[],minIndex:number,maxIndex:number,updateArray:Function,speed:number=50,updateStats?:(stats: { comparisons?: number; swaps?: number }) => void):Promise<void>{
    if(maxIndex<=minIndex){
        return;
    }
    let pivot=await partition(arr,minIndex,maxIndex,updateArray,speed,updateStats);
    await quickSort(arr,minIndex,pivot-1,updateArray,speed,updateStats);
    await quickSort(arr,pivot+1,maxIndex,updateArray,speed,updateStats);
}

export async function mergeSort(arr:any[],low:number,high:number,updateArray:Function,speed:number=50,updateStats?:(stats: { comparisons?: number; swaps?: number }) => void) {
    let m= Math.floor((low+high)/2);
    if(high<=low){
        return;
    }
    await mergeSort(arr,low,m,updateArray,speed,updateStats);
    await mergeSort(arr,m+1,high,updateArray,speed,updateStats);

    let j=m+1,i=low,k=0;
    let t=[];
    
    for (; i <= m && j<=high;) {
            if (updateStats) {
                updateStats({ comparisons: 1 }); // Increment by 1
            }
            if(arr[i].value<arr[j].value){
                t[k]=arr[i];
                i++;
            }else{
                t[k]=arr[j];
                j++;
            }
            k++;
    }
    for(;i<=m;){
        t[k]=arr[i];
        i++;
        k++;
    }
    for(;j<=high;){
        t[k]=arr[j];
        j++;
        k++;
    }
    for(i=low,k=0;i<=high;i++){
        arr[i]=t[k++];
        if (updateStats) {
            updateStats({ swaps: 1 }); // Increment by 1
        }
        await sleep(speed);
        updateArray(arr);
    }
}

export async function bubbleSort(arr:any[],updateArray:Function,speed:number=50,updateStats?:(stats: { comparisons?: number; swaps?: number }) => void) {
    let i,j;
    
    for(i=0;i<arr.length-1;i++){
        for(j=i;j<arr.length;j++){
            if (updateStats) {
                updateStats({ comparisons: 1 }); // Increment by 1
            }
            if(arr[i].value>arr[j].value){
                await swap(arr,i,j,updateArray,speed);
                if (updateStats) {
                    updateStats({ swaps: 1 }); // Increment by 1
                }
            }
        }
    }
}

async function heapify(arr:any[],n:number,i:number,updateArray:Function,speed:number=50,updateStats?:(stats: { comparisons?: number; swaps?: number }) => void) {
    let largest=i,l,r;
    l=2*i +1;
    r=2*i +2;

    if(l<n && arr[largest].value<arr[l].value){
        largest=l;
    }
    if(r<n && arr[largest].value<arr[r].value){
        largest=r;
    }
    
    // Track comparisons
    if (updateStats) {
        updateStats({ comparisons: 2 }); // Two comparisons above
    }
    
    if(largest!=i){
        await swap(arr,i,largest,updateArray,speed);
        if (updateStats) {
            updateStats({ swaps: 1 }); // One swap
        }
        await heapify(arr,n,largest,updateArray,speed,updateStats);
    }
    
}
export async function heapSort(arr:any[],updateArray:Function,speed:number=50,updateStats?:(stats: { comparisons?: number; swaps?: number }) => void) {
    let i,n=arr.length;
    
    for(i=Math.floor(n/2)-1;i>=0;i--){
        await heapify(arr,n,i,updateArray,speed,updateStats);
    }
    for(i=n-1;i>0;i--){
        await swap(arr,i,0,updateArray,speed);
        if (updateStats) {
            updateStats({ swaps: 1 }); // Increment by 1
        }
        await heapify(arr,i,0,updateArray,speed,updateStats);
    }
}